module.exports = __webpack_public_path__ + "img/bg_space5.cd059f7a.png";